var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.12,
    height: 17.12,
    viewBox: "0 0 17.12 17.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.12,8.56a.82.82,0,0,1-.82.82H9.38V12.3a.82.82,0,0,1-1.64,0V9.38H4.82a.82.82,0,0,1,0-1.64H7.74V4.82a.82.82,0,0,1,1.64,0V7.74H12.3A.82.82,0,0,1,13.12,8.56Zm4,0A8.56,8.56,0,1,1,8.56,0,8.56,8.56,0,0,1,17.12,8.56Zm-1.64,0a6.92,6.92,0,1,0-6.92,6.92h0A6.92,6.92,0,0,0,15.48,8.56Z",
    fill: "#d163ab"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd2);
export default __webpack_public_path__ + "static/media/add-2.1b5a823ef14a6d188c2d9faa25a9f555.svg";
export { ForwardRef as ReactComponent };